// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".registrationManagement_batchReview_dialog .el-dialog .el-dialog__footer{margin-top:-18px}.registrationManagement_batchReview_dialog .el-dialog .el-dialog__footer .desc{margin-top:-20px;font-weight:700;text-align:left;color:#d9001b}", ""]);
// Exports
module.exports = exports;
